/** Kamera-Scan auf Geräten mit getUserMedia (typisch Mobil + Webcam). */
export function canUseBarcodeCamera(): boolean {
  if (typeof navigator === "undefined") return false;
  return Boolean(navigator.mediaDevices?.getUserMedia);
}

/** Grobes Mobil/Touch-Gerät – Kamera-Button primär dort anzeigen. */
export function prefersMobileBarcodeCamera(): boolean {
  if (typeof window === "undefined") return false;
  const coarsePointer = window.matchMedia("(pointer: coarse)").matches;
  const narrow = window.matchMedia("(max-width: 768px)").matches;
  return coarsePointer || narrow;
}
